import React from 'react';

function GameTable({ players, gameSession, currentUser, onPlayerAction, onGameAction }) {
  // 计算玩家座位位置（圆形排列）
  const getPlayerPosition = (index, total) => {
    const angle = (index * 2 * Math.PI) / total;
    const radius = 45; // 百分比
    const x = 50 + radius * Math.cos(angle - Math.PI / 2);
    const y = 50 + radius * Math.sin(angle - Math.PI / 2);
    return { x, y };
  };

  // 游戏状态显示
  const getGameStageText = (stage) => {
    const stages = {
      'preflop': '翻牌前',
      'flop': '翻牌圈',
      'turn': '转牌圈',
      'river': '河牌圈',
      'showdown': '摊牌'
    };
    return stages[stage] || '等待中';
  };

  const activePlayers = players.filter(p => p.is_active);
  const totalPlayers = activePlayers.length;

  return (
    <div style={{ margin: '20px 0' }}>
      {/* 游戏桌面 */}
      <div className="game-table">
        {/* 中央信息显示 */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          color: 'white',
          fontSize: '14px',
          fontWeight: 'bold'
        }}>
          {gameSession ? (
            <div>
              <div style={{ fontSize: '16px', marginBottom: '8px' }}>
                {getGameStageText(gameSession.game_stage)}
              </div>
              <div style={{ fontSize: '12px', color: '#fbbf24' }}>
                底池: {gameSession.pot_amount || 0}
              </div>
              {gameSession.current_bet > 0 && (
                <div style={{ fontSize: '12px', color: '#10b981' }}>
                  当前注: {gameSession.current_bet}
                </div>
              )}
            </div>
          ) : (
            <div>
              <div style={{ fontSize: '16px', marginBottom: '8px' }}>
                🃏 等待游戏开始
              </div>
              <div style={{ fontSize: '12px', color: '#9ca3af' }}>
                {totalPlayers}/6 玩家
              </div>
            </div>
          )}
        </div>

        {/* 玩家座位 */}
        {activePlayers.map((player, index) => {
          const position = getPlayerPosition(index, totalPlayers);
          const isCurrentTurn = gameSession?.current_player_id === player.id;
          const isCurrentUser = player.id === currentUser.id;

          return (
            <div
              key={player.id}
              className={`player-seat ${isCurrentTurn ? 'current-turn' : ''} occupied`}
              style={{
                left: `${position.x}%`,
                top: `${position.y}%`,
                transform: 'translate(-50%, -50%)',
                background: isCurrentUser ? '#3b82f6' : '#1f2937',
                borderColor: isCurrentUser ? '#2563eb' : 
                            isCurrentTurn ? '#fbbf24' : '#374151'
              }}
            >
              <div style={{ textAlign: 'center', fontSize: '10px' }}>
                <div style={{ fontWeight: 'bold' }}>
                  {player.player_name}
                </div>
                <div style={{ fontSize: '8px', color: '#d1d5db' }}>
                  {player.chips}
                </div>
                {player.is_host && (
                  <div style={{ fontSize: '8px', color: '#fbbf24' }}>
                    房主
                  </div>
                )}
              </div>
            </div>
          );
        })}

        {/* 空座位 */}
        {Array.from({ length: Math.max(0, 6 - totalPlayers) }).map((_, index) => {
          const position = getPlayerPosition(totalPlayers + index, 6);
          return (
            <div
              key={`empty-${index}`}
              className="player-seat"
              style={{
                left: `${position.x}%`,
                top: `${position.y}%`,
                transform: 'translate(-50%, -50%)'
              }}
            >
              <div style={{ textAlign: 'center', fontSize: '10px', color: '#6b7280' }}>
                空位
              </div>
            </div>
          );
        })}
      </div>

      {/* 游戏操作按钮 */}
      {gameSession && gameSession.current_player_id === currentUser.id && (
        <div className="action-buttons">
          <button 
            className="btn btn-secondary"
            onClick={() => onGameAction && onGameAction('fold', 0)}
          >
            盖牌
          </button>
          <button 
            className="btn btn-primary"
            onClick={() => onGameAction && onGameAction('call', gameSession.current_bet)}
          >
            跟注 {gameSession.current_bet > 0 ? `(${gameSession.current_bet})` : ''}
          </button>
          <button 
            className="btn btn-success"
            onClick={() => {
              const raiseAmount = prompt('请输入加注金额:', gameSession.current_bet + 50);
              if (raiseAmount && !isNaN(raiseAmount)) {
                onGameAction && onGameAction('raise', parseInt(raiseAmount));
              }
            }}
          >
            加注
          </button>
        </div>
      )}

      {/* 游戏状态信息 */}
      {!gameSession && (
        <div style={{
          textAlign: 'center',
          padding: '20px',
          backgroundColor: 'rgba(31, 41, 55, 0.8)',
          borderRadius: '12px',
          margin: '20px 0'
        }}>
          <h3 style={{ color: '#fbbf24', marginBottom: '10px' }}>
            等待游戏开始
          </h3>
          <p style={{ color: '#9ca3af', fontSize: '14px' }}>
            {totalPlayers < 2 ? 
              `需要至少2名玩家才能开始游戏 (当前 ${totalPlayers} 人)` : 
              '房主可以开始游戏'
            }
          </p>
        </div>
      )}
    </div>
  );
}

export default GameTable; 